module.exports = __webpack_public_path__ + "static/media/03-cht.11d6e623.png";